function togglePopup(button) {
  var targetParent = button.getAttribute('data-parent');
  var targetElement = document.querySelector('.' + targetParent);

  if (!targetElement) {
    console.error('No element found with the class:', targetParent);
    return;
  }

  if (targetElement.classList.contains('newsletter-popup-hidden')) {
    console.log('Showing the popup...');
    targetElement.classList.remove('newsletter-popup-hidden');
  } else {
    console.log('Hiding the popup...');
    targetElement.classList.add('newsletter-popup-hidden');
    setPopupClosed();
  }
}

function setPopupClosed() {
  var now = new Date();
  var expirationTime = now.getTime() + (6 * 60 * 60 * 1000); // 6 hours from now
  sessionStorage.setItem('popupClosed', expirationTime);
}

function isPopupClosed() {
  var popupClosed = sessionStorage.getItem('popupClosed');
  if (popupClosed) {
    var now = new Date().getTime();
    if (now < popupClosed) {
      return true; // Popup should not be shown
    } else {
      sessionStorage.removeItem('popupClosed'); // Expired, remove it
    }
  }
  return false; // Popup should be shown
}

document.addEventListener('DOMContentLoaded', function () {
  var popupButton = document.querySelector('button[data-parent]'); // Adjust the selector to target your specific button
  var targetParent = popupButton.getAttribute('data-parent');
  var targetElement = document.querySelector('.' + targetParent);

  if (isPopupClosed()) {
    targetElement.classList.add('newsletter-popup-hidden'); // Ensure popup stays hidden
  } else {
    targetElement.classList.remove('newsletter-popup-hidden'); // Show popup if not closed
  }

  // Ensure the click event is only bound once
  popupButton.addEventListener('click', function () {
    togglePopup(this);
  }, { once: true });
});
